import axios from 'axios';

class InquiryService {

    getInquiries(token) {
        return axios.get('/api/user/' + token + '/get-inquiries').then((response) => response.data);
    }

    getInquiry(token, inquiryId) {
        return axios.get('/api/user/' + token + '/get-inquiry/' + inquiryId).then((response) => response.data);
    }

    sendInquiry(hash, inquiryId) {
        return axios.post('/api/user/' + hash + '/send-inquiry/' + inquiryId).then((response) => response.data);
    }

    getAnswersByInquiryId(hash, inquiryId) {
        return axios.get('/api/user/' + hash + '/get-answers/' + inquiryId).then((response) => response.data);
    }
}

export default new InquiryService();
